import "../Style/DataRow.css"

const DataCell = (props) => {

    return (

        <>
            {
                props.isTrainloadData ? (
                    <div className={props.isColor ? `data-cell ${DecideColor(props.passengerCount)}` : "data-cell"}  >
                        <div>
                            {
                                props.data
                            }
                        </div>
                        {
                            props.carId ?
                                <div>
                                    {props.carId}
                                </div>
                                : ""
                        }
                    </div>

                ) : (
                    <div className={props.isColor ? `data-cell ${DecideColor(props.passengerCount)}` : "data-cell"}  >
                        {
                            props.data
                        }
                    </div>
                )
            }
        </>


    );
}

function DecideColor(passengerCount) {
    switch (passengerCount) {
        case 0:
            return "data-cell-green";
        case 1:
            return "data-cell-green";
        case 2:
            return "data-cell-yellow";
        case 3:
            return "data-cell-red";
        default:
            return "";
    }
}

export default DataCell;